export default __webpack_public_path__ + "static/media/Clan Bound Helm of the Ancestors.652498d2.jpg";